import { Alert, Button, Form, notification, Row } from "antd";
import { useEffect, useState } from "react";
import TagsInput from "../../Remitentes/AddEmailsComponent";
import useForm from "../../../../hooks/useForm";
import useRequest from "../../../../hooks/useRequest";
// import useGet from "../../../../hooks/useGet";
import { UseAdmin } from "../../../../hooks";
import createAxiosInstanceNew from "../../../../Api/AxiosInstance/AxiosInstance";
import { useUploadCsvSteps } from "../../../../hooks/Faltantes/useUploadCsvSteps";

export default function EditSenders() {
  const [api, contextHolder] = notification.useNotification();

  const { branchFiPaisId, brandfiMarcaId } = UseAdmin();

  const { setIsBlocked } = useUploadCsvSteps();

  const { values, handleChange, resetForm, setInitialValues } = useForm({
    marcaId: 0,
    branchName: "",
    emails: [],
  });

  const [refetch, setRefetch] = useState(false);

  const [initialEmails, setInitialEmails] = useState([]);

  const [loadingSenders, setLoadingSenders] = useState(false);

  const getRemitentes = async () => {
    setLoadingSenders(true);
    try {
      const axiosInstance = await createAxiosInstanceNew();
      const response = await axiosInstance.get("faltante/remitente", {
        params: {
          FIPAISID: branchFiPaisId,
          FIMARCAID: brandfiMarcaId,
        },
      });

      if (response.data.statusCode === 200) {
        setInitialValues({
          marcaId: response.data.body[0].FIMARCAID,
          emails: response.data.body[0].FCLISTAREMITENTES.split(","),
        });
        setInitialEmails(response.data.body[0].FCLISTAREMITENTES.split(","));
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setLoadingSenders(false);
    }
  };

  const triggerRefetch = () => {
    setRefetch((prev) => !prev);
  };

  useEffect(() => {
    getRemitentes();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchFiPaisId, brandfiMarcaId, refetch]);

  const openNotificationWithIcon = (type, message, description = "") => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const { request, loading, success, resetRequestValues } = useRequest();

  const isDisabled = () => {
    return values?.emails?.length === 0 || values?.emails?.join(",") === initialEmails.join(",");
  };

  useEffect(() => {
    if (initialEmails.length === 0) {
      setIsBlocked(true);
    } else {
      setIsBlocked(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialEmails]);

  const handleSubmitEdit = async () => {
    const data = {
      FIMARCAID: parseInt(brandfiMarcaId),
      FCLISTAREMITENTES: values.emails.join(","),
      FITIPOREPORTEID: 1 /* 1: Ingresos Faltantes */,
      FIPAISID: parseInt(branchFiPaisId),
    };

    await request({
      endPoint: "faltante/remitente",
      method: "put",
      data,
    });
  };

  useEffect(() => {
    if (success) {
      openNotificationWithIcon("success", ` Editado correctamente.`);
      triggerRefetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  return (
    <>
      {contextHolder}
      <Row justify="center">
        {isDisabled() && (
          <Alert
            message="Para poder editar, elimine o agregue los correos que desee."
            type="warning"
            showIcon
          />
        )}
      </Row>
      <Row justify="space-around" className="mt-2">
        {/* <Col span={24}>
          <div className="input-content-titulo">Editar remitentes</div>
        </Col> */}

        <Form
          name="AddRemitente"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
        >
          <div className="text-context-inputs">Email(s):</div>
          <TagsInput values={values} handleChange={handleChange} />

          <Button
            type="primary"
            htmlType="submit"
            disabled={isDisabled() || loading}
            className="button-styles-add-element"
            onClick={handleSubmitEdit}
            style={{ marginTop: 20 }}
            loading={loadingSenders || loading}
          >
            {
              // eslint-disable-next-line no-nested-ternary
              loadingSenders || loading ? "Cargando..." : "Editar"
            }
          </Button>
        </Form>
      </Row>
    </>
  );
}
